import { PayoutMethodAPI } from 'payouts/pro/API'
import { Id } from 'types/definitions'
import { GetCurrentUser } from '../../iam/SessionStore'

export default class AdminPayoutMethodStore {
  /**
   * Constructor.
   */
  constructor(
    private readonly _getCurrentUser: GetCurrentUser,
    private payoutMethodApi?: PayoutMethodAPI,
  ) {}

  /**
   * Fetches payout method for a user using BigMoney API.
   */
  async fetchPayoutMethodInfo(userPublicId: Id): Promise<PayoutMethodInfo> {
    if (!this.payoutMethodApi) {
      return { status: 'Unknown' }
    }

    if (this._getCurrentUser().platformAdmin) {
      return await this.payoutMethodApi
        .getByUserPublicId(Id.assert(userPublicId))
        .then(
          (method): PayoutMethodInfo => ({
            status: 'Connected',
            stripeAccountId: method.stripe_account_id,
          }),
        )
        .catch((err) => {
          if (err.response?.status === 404 || err.statusCode === 404) {
            return { status: 'NotConnected' }
          }

          throw err
        })
    }

    return await this.payoutMethodApi
      .getStatusByUserPublicId(Id.assert(userPublicId))
      .then(
        ({ status }): PayoutMethodInfo => ({
          status: status === 'CONNECTED' ? 'Connected' : 'NotConnected',
          stripeAccountId: null,
        }),
      )
  }
}

/**
 * Info about a user's payout method.
 */
export type PayoutMethodInfo =
  | { status: 'Connected'; stripeAccountId: string | null }
  | { status: 'NotConnected' }
  | { status: 'Unknown' }
